import React from 'react';
import { FileText, Mail, Phone } from "lucide-react"
import { useTranslation } from "react-i18next"; // 1. Import i18next

const RegistrationFooter: React.FC = () => {
    const { t } = useTranslation('registration'); // 2. Gunakan namespace

    return (
        <section className="bg-muted dark:bg-gray-800 py-8 md:py-12">
            <div className="container mx-auto px-4 text-center">
                <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 dark:text-white">
                    {t('registration_footer.help_title')}
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 max-w-3xl mx-auto text-left md:text-center">
                    {/* Email */}
                    <div className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background dark:bg-gray-700 shadow-sm transition-transform hover:scale-105">
                        <Mail className="w-6 h-6 md:w-8 md:h-8 text-primary dark:text-blue-400" />
                        <h3 className="font-semibold text-sm md:text-base dark:text-white">
                            {t('registration_footer.labels.email')}
                        </h3>
                        <p className="text-xs md:text-sm text-muted-foreground dark:text-gray-300">
                            konaspixii@undiksha.ac.id
                        </p>
                    </div>

                    {/* Telepon */}
                    <div className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background dark:bg-gray-700 shadow-sm transition-transform hover:scale-105">
                        <Phone className="w-6 h-6 md:w-8 md:h-8 text-primary dark:text-blue-400" />
                        <h3 className="font-semibold text-sm md:text-base dark:text-white">
                            {t('registration_footer.labels.phone')}
                        </h3>
                        <p className="text-xs md:text-sm text-muted-foreground dark:text-gray-300">
                            (0362) 22570
                        </p>
                    </div>

                    {/* Panduan */}
                    <div className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background dark:bg-gray-700 shadow-sm cursor-pointer group transition-transform hover:scale-105">
                        <FileText className="w-6 h-6 md:w-8 md:h-8 text-primary dark:text-blue-400 group-hover:text-blue-600" />
                        <h3 className="font-semibold text-sm md:text-base dark:text-white">
                            {t('registration_footer.labels.guide')}
                        </h3>
                        <p className="text-xs md:text-sm text-muted-foreground dark:text-gray-300 group-hover:text-primary transition-colors">
                            {t('registration_footer.guide_desc')}
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default RegistrationFooter;